module.exports = __webpack_public_path__ + "media/images/arrow-prev-df734dd32a5f35cd33809de3c33189a9.svg";